export const f = (float: number, multiplier: number = 1000) => Math.round(float * multiplier) / multiplier